import script from "./batchGoodsTempRemoveRecover.vue?vue&type=script&setup=true&lang=js"
export * from "./batchGoodsTempRemoveRecover.vue?vue&type=script&setup=true&lang=js"

import "./batchGoodsTempRemoveRecover.vue?vue&type=style&index=0&id=33aec2ab&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33aec2ab"]])

export default __exports__